import http from "./http-common";
import _ from "lodash";

class DrugServices {
  constructor() {
    this.debouncedDrugList = _.debounce((medicineName) => {
      return this.fetchDrugList(medicineName);
    }, 150);
  }

  DrugList(medicineName) {
    return this.debouncedDrugList(medicineName);
  }

  fetchDrugList(medicineName) {
    return http.get(
      `/drugInfo/list/filter?medicineName=${medicineName}&pageNo=${1}`
    );
  }

  fetchDrugListnew(payload) {
    var queryString = Object.keys(payload)
      .map((key) => (key && payload[key] ? key + "=" + payload[key] : ""))
      .join("&");
    return http.get(`/drugInfo/listMdmDrug?${queryString}`);
  }
}

export default new DrugServices();
